import { useCallback, useEffect, useState } from 'react';

const useViewMoreElements = (targetIndex: number | null, maxParentLength: number) => {
  const [currentIndex, setIndex] = useState<null | number>(null);
  const [shouldRenderCTA, setShouldRenderCTA] = useState(false);

  useEffect(() => {
    if (targetIndex) {
      setIndex(targetIndex);
      setShouldRenderCTA(true);
    }
  }, [targetIndex]);

  useEffect(() => {
    if (currentIndex >= maxParentLength) {
      setShouldRenderCTA(false);
    }
  }, [maxParentLength, currentIndex]);

  const incrementViewMoreCount = useCallback(() => {
    setIndex(currentIndex + targetIndex);
  }, [targetIndex, currentIndex]);

  return { currentIndex, incrementViewMoreCount, shouldRenderCTA };
};

export default useViewMoreElements;
